const INITIAL_STATE = {
    filters: [],
    count: 0,
    loading: false
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case "GET_FILTERS": {
        return {
          ...state,
          filters: action.data,
          count: action.count,
          loading: false
        }
      }
      default:
        return state
    }
  }
  